import { useNavigate } from "react-router-dom";
import InputField from "../../public-page/components/InputFeild";
import { useEffect, useRef, useState } from "react";
import { ReactComponent as LockIcon } from "../../../assets/icons/lock.svg";
import { toast } from "react-toastify";
import { motion, useReducedMotion } from "framer-motion";
import MobilePatternHeader from "../components/MobilePatternHeader";
// import { userService } from "../../../services/api/authenService";
// import { AuthContext } from "../../../contexts/AuthContext";
// import { accountService } from "../../../../services/api/accountService"; // nếu có API thật, bật dòng này

const PasswordReset = () => {
  const navigate = useNavigate();
  const shouldReduceMotion = useReducedMotion();
  // const { token_client } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [focusField, setFocusField] = useState("");
  const [formData, setFormData] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState({
    old: false,
    new: false,
    confirm: false,
  });

  // ---- Animations
  const containerV = {
    hidden: { opacity: 0, y: 8 },
    show: { opacity: 1, y: 0, transition: { duration: 0.22 } },
  };
  const cardV = {
    hidden: { opacity: 0, scale: 0.98 },
    show: { opacity: 1, scale: 1, transition: { duration: 0.22 } },
  };
  const shakeV = {
    x: [0, -6, 6, -4, 4, -2, 2, 0],
    transition: { duration: 0.35 },
  };

  // ---- Handlers
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((s) => ({ ...s, [name]: value }));
    setErrors((s) => ({ ...s, [name]: "" }));
  };

  const handleFocus = (field) => setFocusField(field);
  const handleBlur = () => setFocusField("");

  const validate = () => {
    const err = {};
    const { oldPassword, password, confirmPassword } = formData;
    if (!oldPassword.trim())
      err.oldPassword = "Vui lòng nhập mật khẩu hiện tại.";
    if (!password.trim()) err.password = "Vui lòng nhập mật khẩu mới.";
    if (!confirmPassword.trim())
      err.confirmPassword = "Vui lòng nhập lại mật khẩu mới.";

    // quy tắc mạnh
    if (password && password.length < 6) err.password = "Tối thiểu 6 ký tự.";
    // if (password && !/[A-Z]/.test(password))
    //   err.password = "Cần ít nhất 1 chữ hoa (A-Z).";
    // if (password && !/[a-z]/.test(password))
    //   err.password = "Cần ít nhất 1 chữ thường (a-z).";
    // if (password && !/\d/.test(password))
    //   err.password = "Cần ít nhất 1 chữ số (0-9).";
    // if (password && !/[^A-Za-z0-9]/.test(password))
    //   err.password = "Cần ít nhất 1 ký tự đặc biệt.";

    if (password && oldPassword && password === oldPassword)
      err.password = "Mật khẩu mới không được trùng mật khẩu hiện tại.";

    if (password && confirmPassword && password !== confirmPassword)
      err.confirmPassword = "Mật khẩu nhập lại không khớp.";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const submitRef = useRef(null);

  const handleSubmit = async () => {
    if (!validate()) {
      // lắc card khi lỗi
      if (submitRef.current) submitRef.current.start(shakeV);
      return;
    }
    setIsLoading(true);
    toast.info(
      "HIỆN TẠI CHƯA CÓ TÍNH NĂNG ĐỔI MẬT KHẨU, VUI LÒNG THỬ LẠI SAU!"
    );
    setIsLoading(false);
    // try {
    //   setIsLoading(true);
    //   // Gọi API thực tế của bạn tại đây:
    //   // await userService.reset_password(token_client, formData.password);

    //   // Demo giả lập:
    //   await new Promise((r) => setTimeout(r, 800));

    //   toast.success("Cập nhật mật khẩu thành công!");
    //   navigate(-1);
    // } catch (err) {
    //   // Hiển thị lỗi từ server nếu có
    //   toast.error("Cập nhật mật khẩu thất bại. Vui lòng thử lại.");
    // } finally {
    //   setIsLoading(false);
    // }
  };

  const disabled =
    isLoading ||
    !formData.oldPassword ||
    !formData.password ||
    !formData.confirmPassword;

  useEffect(() => {
    // Xoá lỗi “password không khớp” khi người dùng đang gõ lại
    if (
      errors.confirmPassword &&
      formData.confirmPassword === formData.password
    ) {
      setErrors((s) => ({ ...s, confirmPassword: "" }));
    }
  }, [formData.confirmPassword, formData.password, errors.confirmPassword]);

  return (
    <motion.div
      className="h-full w-full"
      variants={containerV}
      initial="hidden"
      animate="show"
    >
      {/* Back */}

      {/* Title */}
      <MobilePatternHeader
        title="Đặt lại mật khẩu"
        onBack={() => navigate(-1)}
      />

      <div className="h-[calc(100%-64px)] bg-[#F2F2F2] p-3">
        <div className="overflow-auto h-[calc(100%-130px)]">
          <motion.div
            className="bg-white p-3 space-y-3 rounded-lg"
            variants={cardV}
            initial="hidden"
            animate="show"
          >
            <div>
              <p className="font-sf-semibold">Đổi mật khẩu</p>
              <p className="opacity-50">Nhập thông tin để thay đổi mật khẩu</p>
            </div>

            {/* Card “shake” khi submit lỗi */}
            <motion.div animate={submitRef} className="space-y-3">
              <InputField
                label="Nhập mật khẩu hiện tại"
                type={show.old ? "text" : "password"}
                name="oldPassword"
                placeholder="Nhập mật khẩu"
                IconComponent={LockIcon}
                value={formData.oldPassword}
                onChange={handleChange}
                toggleVisibility={() => setShow((s) => ({ ...s, old: !s.old }))}
                showPassword={show.old}
                error={errors.oldPassword} // fix: olePassword -> oldPassword
                iconColor={focusField === "oldPassword" ? "#1D4ED8" : "#9E9E9E"}
                onFocus={() => handleFocus("oldPassword")}
                onBlur={handleBlur}
              />

              <InputField
                label="Mật khẩu mới"
                type={show.new ? "text" : "password"}
                name="password"
                placeholder="Nhập mật khẩu"
                IconComponent={LockIcon}
                value={formData.password}
                onChange={handleChange}
                toggleVisibility={() => setShow((s) => ({ ...s, new: !s.new }))}
                showPassword={show.new}
                error={errors.password}
                iconColor={focusField === "password" ? "#1D4ED8" : "#9E9E9E"}
                onFocus={() => handleFocus("password")}
                onBlur={handleBlur}
              />
              {/* Tips quy tắc (ẩn khi có lỗi lớn để tránh quá tải info) */}
              {!errors.password && (
                <ul className="mt-2 list-disc pl-5 text-xs text-gray-500 space-y-1">
                  <li>Tối thiểu 6 ký tự.</li>
                  <li>Không dùng mật khẩu mới trùng với mật khẩu hiện tại.</li>
                </ul>
              )}
              <InputField
                label="Nhập lại mật khẩu mới"
                type={show.confirm ? "text" : "password"}
                name="confirmPassword"
                placeholder="Nhập mật khẩu"
                IconComponent={LockIcon}
                value={formData.confirmPassword}
                onChange={handleChange}
                toggleVisibility={() =>
                  setShow((s) => ({ ...s, confirm: !s.confirm }))
                }
                showPassword={show.confirm}
                error={errors.confirmPassword}
                iconColor={
                  focusField === "confirmPassword" ? "#1D4ED8" : "#9E9E9E"
                }
                onFocus={() => handleFocus("confirmPassword")}
                onBlur={handleBlur}
              />
            </motion.div>
          </motion.div>
        </div>
      </div>

      {/* Sticky actions */}
      <div className="w-full p-3 absolute bottom-[85px]">
        <motion.button
          onClick={handleSubmit}
          disabled={disabled}
          whileTap={shouldReduceMotion ? {} : { scale: 0.99 }}
          className={`w-full mt-3 font-sf-medium text-white py-3 rounded-lg transition ${
            isLoading
              ? "bg-blue-400 cursor-wait"
              : !disabled
              ? "bg-blue-500 hover:bg-blue-600"
              : "bg-gray-300 cursor-default"
          }`}
        >
          {isLoading ? "Đang cập nhật..." : "Cập nhật mật khẩu"}
        </motion.button>
      </div>
    </motion.div>
  );
};

export default PasswordReset;
